import React from 'react';
import { SectionList as RNSectionList, SectionListProps as RNSectionListProps } from 'react-native';

export type SectionListProps<T, U> = RNSectionListProps<T, U>;

export default function SectionList<T, U>(props: SectionListProps<T, U>) {
  return (
    <RNSectionList
      keyboardShouldPersistTaps="handled"
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
      removeClippedSubviews={false}
      stickySectionHeadersEnabled
      {...props}
    />
  );
}

type Section<T> = {
  data: T[];
  title: string;
};

export type EncapsulatedSectionListProps<T, U, TSection = Section<T>> = Omit<
  SectionListProps<T, TSection>,
  'renderItem' | 'keyExtractor'
> & {
  // Note: we require itemProps because the item may have required props
  // that we want to enforce. If itemProps is optional, then the required
  // props of the underlying item component would not be enforced.
  itemProps: U;
};
